import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { useDegrees } from "../../../hooks/useDegrees";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  document_type_id: Yup.string().required(
    "El tipo de documento es obligatorio"
  ),
  identification: Yup.string().required("La identificación es obligatoria"),
  first_name: Yup.string().required("El nombre es obligatorio"),
  last_name: Yup.string().required("El apellido es obligatorio"),
  email: Yup.string().email("El formato del correo electrónico no es válido"),
  cellphone: Yup.string(),
  degree_id: Yup.number().required("El grado es obligatorio"),
});

const StudentCreate = ({ refetchStudent }) => {
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear().toString());
  const { getData, postData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { degrees: datadegreeList } = useDegrees(yearFilter);

  const { data: datadocumenttype } = getData(
    ["document-type"],
    "/document-type",
    {
      enabled: true,
    }
  );

  const { mutate: createStudent, isLoading: isPostLoading } = postData(
    "/students",
    {},
    {},
    {
      onSuccess: (data) => {
        refetchStudent();
        reset();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const onSubmit = (data) => {
    createStudent({
      ...data,
      status: true,
      gender: "male",
      phone: "",
      address: "",
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div
          className={`col-md-4 mb-3 ${
            errors.document_type_id?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="state">Tipo de documento</label>
          <select className="form-control" {...register("document_type_id")}>
            <option value="">Seleccione...</option>
            {datadocumenttype?.data?.map((e) => (
              <option value={e.id}>{e.name}</option>
            ))}
          </select>

          {errors.document_type_id?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.document_type_id?.message}
            </div>
          ) : null}
        </div>

        <div
          className={`col-md-4 mb-3 ${
            errors.identification?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Identificación</label>
          <input
            type="text"
            className="form-control"
            {...register("identification")}
          />

          {errors.identification?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.identification?.message}
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-4 mb-3 ${
            errors.first_name?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Nombres</label>
          <input
            type="text"
            className="form-control"
            {...register("first_name")}
          />

          {errors.first_name?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.first_name?.message}
            </div>
          ) : null}
        </div>
      </div>
      <div className="row">
        <div
          className={`col-md-4 mb-3 ${
            errors.last_name?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Apellidos</label>
          <input
            type="text"
            className="form-control"
            {...register("last_name")}
          />

          {errors.last_name?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.last_name?.message}
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-4 mb-3 ${
            errors.email?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Correo electrónico</label>
          <input type="text" className="form-control" {...register("email")} />

          {errors.email?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.email?.message}
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-4 mb-3 ${
            errors.cellphone?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Celular</label>
          <input
            type="text"
            className="form-control"
            {...register("cellphone")}
          />

          {errors.cellphone?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.cellphone?.message}
            </div>
          ) : null}
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="year">Año</label>
          <select
            className="form-control"
            value={yearFilter}
            onChange={(e) => setYearFilter(e.target.value)}
          >
            {[2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div
          className={`col-md-4 mb-3 ${
            errors.degree_id?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="state">Grado</label>
          <select className="form-control" {...register("degree_id")}>
            <option value="">Seleccione...</option>
            {datadegreeList?.map((e) => (
              <option key={e.id} value={e.id}>
                {e.level} {e.degree}
              </option>
            ))}
          </select>

          {errors.degree_id?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.degree_id?.message}
            </div>
          ) : null}
        </div>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="submit"
        disabled={isPostLoading}
      >
        Guardar
      </button>
    </form>
  );
};

export default StudentCreate;
